import { RootState } from '../RootState';
import { initialPanelComerciales } from './panel_comerciales.initial';

const slice = (state: RootState) => state.panel_comerciales ?? initialPanelComerciales;

export const selectPanelComerciales = (state: RootState) => slice(state);
export const selectPanelMeta = (state: RootState) => slice(state).snapshot.meta;
/**
 * Productos retirados de la configuración del panel (decisión 2026-07): el
 * negocio no distribuye Anuncio Simple ni Smart Leads entre comerciales. El
 * backend ya los filtra vía `distribution_enabled=0`; este filtro cubre además
 * el catálogo INFERIDO de porcentajes legacy guardados (api.ts) para que no
 * reaparezcan en el editor.
 */
export const NON_CONFIGURABLE_PRODUCTS: readonly string[] = [
    'ANUNCIO_SIMPLE',
    'SMART_LEADS',
];
/** EJE PRODUCTO. Catálogo de productos (key = product_code). */
export const selectProducts = (state: RootState) =>
    (slice(state).snapshot.meta.products ?? []).filter(
        (p) => !NON_CONFIGURABLE_PRODUCTS.includes(p.key),
    );
/**
 * Flujos que NO se reparten por porcentaje (spec ago-2026): se gobiernan con
 * un TOGGLE por comercial fuera del modal de distribución.
 *   - MARKETING  → switch "Campañas".
 *   - RENOVACION → switch "Renovación".
 * El backend ya los excluye del catálogo; este filtro cubre además el catálogo
 * INFERIDO de porcentajes legacy guardados (api.ts) para que no reaparezcan.
 */
export const NON_CONFIGURABLE_FLOWS: readonly string[] = [
    'MARKETING',
    'RENOVACION',
];
/** EJE FLUJO. Catálogo de tipos de flujo (key = pipeline_key). */
export const selectFlowTypes = (state: RootState) =>
    (slice(state).snapshot.meta.flowTypes ?? []).filter(
        (f) => !NON_CONFIGURABLE_FLOWS.includes(f.key),
    );
export const selectTeams = (state: RootState) => slice(state).snapshot.teams;
export const selectCommercials = (state: RootState) => slice(state).snapshot.commercials;
export const selectVips = (state: RootState) => slice(state).snapshot.vips;
export const selectNotifications = (state: RootState) => slice(state).snapshot.notifications;
export const selectAuditLog = (state: RootState) => slice(state).snapshot.auditLog;
export const selectPanelLoading = (state: RootState) => slice(state).loading;
export const selectPanelSaving = (state: RootState) => slice(state).saving;
export const selectPanelError = (state: RootState) => slice(state).error;
export const selectActiveTeamNames = (state: RootState) =>
    slice(state).snapshot.teams.filter((t) => t.active).map((t) => t.name);

// --- Sección "Estado de deals" (Reglas de Marketing jul-2026) ---
export const selectDealsStatus = (state: RootState) => slice(state).dealsStatus;

// --- Secciones paginadas del panel (ago-2026) ---
export const selectNotificationsPage = (state: RootState) =>
    slice(state).notifications;
export const selectNotificationsLoading = (state: RootState) =>
    slice(state).notificationsLoading;
export const selectActivityPage = (state: RootState) => slice(state).activity;
export const selectActivityLoading = (state: RootState) =>
    slice(state).activityLoading;
